let sentryModulePromise: Promise<typeof import('@sentry/react')> | null = null;
let sentryModule: typeof import('@sentry/react') | null = null;
let sentryInitialized = false;

async function loadSentry() {
  if (sentryModule) return sentryModule;
  if (!sentryModulePromise) {
    sentryModulePromise = import('@sentry/react');
  }
  sentryModule = await sentryModulePromise;
  return sentryModule;
}

async function ensureSentryInit() {
  const Sentry = await loadSentry();
  if (!sentryInitialized) {
    Sentry.init({
      dsn: 'https://6ec83347159aba2c50933064b2b34ff1@o4510205491478528.ingest.de.sentry.io/4510205501177936',
      environment: import.meta.env.MODE,
      integrations: [],
      tracesSampleRate: 0,
      tracePropagationTargets: [],
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 0,
      beforeSend(event) {
        if (import.meta.env.MODE === 'development') {
          console.log('🔍 Sentry event (dev mode):', event);
          return null;
        }
        return event;
      },
    });
    sentryInitialized = true;
  }
  return Sentry;
}

export async function captureExceptionLazy(error: Error, context?: Record<string, any>) {
  const Sentry = await ensureSentryInit();
  return Sentry.captureException(error, { tags: context, extra: context });
}

export async function setSentryUserLazy(user: { id: string; username?: string } | null) {
  const Sentry = await ensureSentryInit();
  Sentry.setUser(user ? { id: user.id, username: user.username } : null);
}

export async function initSentryLazy() {
  return ensureSentryInit();
}
